"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrOptions = void 0;
const vue_1 = require("vue");
const PlayerInputFactory_1 = require("./PlayerInputFactory");
const i18n_1 = require("../directives/i18n");
const Button_1 = require("../components/common/Button");
let unique = 0;
exports.OrOptions = vue_1.default.component('or-options', {
    props: {
        player: {
            type: Object,
        },
        players: {
            type: Array,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            selectedOption: 0,
        };
    },
    methods: {
        saveData: function () {
            const componentInstance = this.$data.childComponents[this.$data.selectedOption].componentInstance;
            if (componentInstance !== undefined) {
                if (componentInstance.saveData instanceof Function) {
                    componentInstance.saveData();
                    return;
                }
            }
            throw new Error('Unexpected unable to save data');
        },
    },
    render: function (createElement) {
        unique++;
        this.$data.childComponents = [];
        const children = [];
        if (this.showtitle) {
            children.push(createElement('label', [
                createElement('div', i18n_1.$t(this.playerinput.title)),
            ]));
        }
        const optionElements = [];
        if (this.playerinput.options === undefined) {
            throw new Error('no options provided for OrOptions');
        }
        this.playerinput.options.forEach((option, idx) => {
            const domProps = {
                name: 'selectOption' + unique,
                type: 'radio',
                value: String(idx),
            };
            const displayStyle = this.$data.selectedOption === idx ? 'block' : 'none';
            const subchildren = [];
            if (this.$data.selectedOption === idx) {
                domProps.checked = true;
            }
            subchildren.push(createElement('label', { 'class': 'form-radio' }, [
                createElement('input', {
                    domProps,
                    on: {
                        change: (event) => {
                            this.selectedOption = Number(event.target.value);
                        },
                    },
                }),
                createElement('i', { 'class': 'form-icon' }),
                createElement('span', i18n_1.$t(option.title)),
            ]));
            this.$data.childComponents.push(new PlayerInputFactory_1.PlayerInputFactory().getPlayerInput(createElement, this.players, this.player, option, (out) => {
                const copy = [[String(idx)]];
                for (let i = 0; i < out.length; i++) {
                    copy.push(out[i].slice());
                }
                this.onsave(copy);
            }, option.buttonLabel === 'Sell', false));
            subchildren.push(createElement('div', { style: { display: displayStyle, marginLeft: '30px' } }, [
                this.$data.childComponents[this.$data.childComponents.length - 1],
            ]));
            optionElements.push(subchildren[subchildren.length - 1]);
            const showOption = true;
            if (showOption) {
                children.push(createElement('div', subchildren));
                if (this.showsave && this.$data.selectedOption === idx && option.buttonLabel !== 'Sell') {
                    children.push(createElement('div', {
                        'style': { 'margin': '5px 30px 10px' },
                        'class': 'wf-action',
                    }, [
                        createElement(Button_1.Button, {
                            props: {
                                title: i18n_1.$t(option.buttonLabel),
                                type: 'submit',
                                size: 'normal',
                                onClick: () => {
                                    this.saveData();
                                },
                            },
                        }),
                    ]));
                }
            }
        });
        return createElement('div', { 'class': 'wf-options' }, children);
    },
});
//# sourceMappingURL=OrOptions.js.map